import React from "react";
import styles from './sell_home.module.css';
import { FaHandPointRight } from "react-icons/fa6";


const HomeSellingServices = () => {
  const services = [
    { 
      title: "Maximum Exposure, Minimum Stress",
      description: "We list your home on top property portals, Google, social media, and targeted ad networks, ensuring high visibility to genuine, ready-to-buy leads."
    },
    { 
      title: "Free Property Evaluation",
      description: "Get a free home valuation report based on current market trends, location demand, and property condition."
    },
    { 
      title: "Professional Marketing & Photography",
      description: "Your home deserves the spotlight. We use HD photography, drone shots, 360° virtual tours, and compelling copywriting to attract serious buyers."
    },
    { 
      title: "Verified Buyers Only",
      description: "No more spam calls or window shoppers. We pre-screen all buyers to ensure serious inquiries only."
    },
    { 
      title: "Legal & Documentation Support",
      description: "From sale agreement to title verification, we help with end-to-end documentation to keep your transaction clean and compliant."
    },
    { 
      title: "Fast Closures, Best Offers",
      description: "We negotiate smartly to secure top offers and close deals faster than market average."
    }
  ];

  const sellingServices = [
    "Home inspection & pricing strategy",
    "Digital and offline marketing campaign",
    "Buyer coordination and home showings",
    "Legal and regulatory compliance",
    "RERA assistance",
    "Final sale negotiation & registration"
  ];

  const stats = [
    { value: "30-45 days", label: "Average Sale Time" },
    { value: "98%", label: "Seller Satisfaction Rate" },
    { value: "1,000+", label: "Homes Sold in top cities" }
  ];

  const testimonials = [
    { 
      quote: "Sold my apartment in Pune within 3 weeks at a great price. The team is professional and transparent throughout.",
      author: "Anjali M., Kalyani Nagar"
    },
    { 
      quote: "Property Plateau Realty handled everything, including paperwork and buyer verification. Highly recommended!",
      author: "Rajesh K., North Goa"
    }
  ];

  return (
    <>
  
    <div className={styles.luxuryContainer}>
      {/* Hero Section with Background Image */}
      <div className={styles.heroSection}>
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>"List. Market. Close."</h1>
          <p className={styles.heroSubtitle}>Expert Home Selling Services Across India</p>
        </div>
      </div>

      {/* Fast. Transparent. Profitable */}
      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Fast. Transparent. Profitable.</h2>
        <p className={styles.sectionText}>
          Looking to sell your property quickly and at the best market price?
          Property Plateau Realty is your trusted real estate partner for hassle-free home selling across India. 
          With data-backed pricing, premium buyer network, and powerful digital marketing, 
          we make your selling journey smooth, secure, and rewarding.
        </p>
      </div>

      {/* Why Choose Us - Card Section */}
      <div className={styles.sectionCard}>
        <h2 className={styles.sectionTitle}>Why Choose Property Plateau to Sell Your Home?</h2>
        <div className={styles.servicesGrid}>
          {services.map((service, index) => (
            <div key={index} className={styles.serviceCard}>
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{service.title}</h3>
                <p className={styles.cardText}>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Our Services - Two Column Section */}
      <div className={styles.twoColumnSection}>
        <div className={styles.servicesListColumn}>
          <h2 className={styles.sectionTitlecolumn}>Our Home Selling Services Includes:</h2>
          <ul className={styles.servicesList}>
            {sellingServices.map((service, index) => (
              <li key={index} className={styles.serviceItem}>
                <span className={styles.serviceBullet}><FaHandPointRight /></span>
                <span>{service}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.servicesImageColumn}>
          <img 
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c" 
            alt="Luxury Home Marketing" 
            className={styles.serviceImage}
          />
        </div>
      </div>

      {/* Stats Section */}
      <div className={styles.statsSection}>
        <h2 className={styles.statsTitle}>We Sell Faster. Smarter. Better.</h2>
        <div className={styles.statsContainer}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statItem}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials */}
      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>What Our Sellers Say</h2>
        <div className={styles.testimonialsGrid}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className={styles.testimonialCard}>
              <p className={styles.testimonialText}>"{testimonial.quote}"</p>
              <p className={styles.testimonialAuthor}>— {testimonial.author}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className={styles.ctaSection}>
        <h2 className={styles.ctaTitle}>Ready to Sell Your Home?</h2>
        <p className={styles.ctaText}>Let our experts help you get the best deal, faster.</p>
        <div className={styles.ctaButtons}>
          <a href="tel:+919156091640" className={styles.ctaButtonPrimary}>
            Book a Call with Our Experts: +91 91560 91640
          </a>
          <a href="#valuation" className={styles.ctaButtonSecondary}>
            Free Property Valuation Report
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default HomeSellingServices;